export enum RiskAssessmentActionTypes {
  //all RiskAssessment
  SetRiskAssessmentApprove = 'SetRiskAssessmentApprove/all',
  SetRiskAssessmentApproveSuccess = 'SetRiskAssessmentApproveSuccess/all',
  SetRiskAssessmentApproveFail = 'SetRiskAssessmentApproveFail/all',
}
